import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { UnauthorizedComponent } from 'src/app/shared/components/unauthorized/unauthorized.component';
// import { ManualEntryConfiguratorComponent } from './manual-entry-configurator/manual-entry-configurator.component';
// import { ReportComponent } from './report/report.component';
// import { UsageReportComponent } from './usage-report/usage-report.component';
const unauthorized = '/spc/no-privilage';
const routes: Routes = [
  // {
  //   path: 'dashboard',
  //   canActivate: [NgxPermissionsGuard],
  //   loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  // },
  // {
  //   path: 'manual-entry',
  //   canActivate: [NgxPermissionsGuard],
  //   data: {
  //     permissions: {
  //       only: 'Manual Entry',
  //       redirectTo: unauthorized,
  //     }
  //   },
  //   component: ManualEntryConfiguratorComponent
  // },
  {
    path: 'process-charts',
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['Line Management'],
        redirectTo: unauthorized,
      }
    },
    loadChildren: () => import('./process-charts/process-charts.module').then(m => m.ProcessChartsModule)
  },
  // {
  //   path: 'daily-report',
  //   canActivate: [NgxPermissionsGuard],
  //   data: {
  //     permissions: {
  //       only: 'Line Management',
  //       redirectTo: unauthorized,
  //     }
  //   },
  //   component: ReportComponent
  // },
  // {
  //   path: 'usage-report',
  //   canActivate: [NgxPermissionsGuard],
  //   data: {
  //     permissions: {
  //       only: 'Line Management',
  //       redirectTo: unauthorized,
  //     }
  //   },
  //   component: UsageReportComponent
  // },
  {
    path: 'no-privilage',
    component: UnauthorizedComponent
  },
  // {
  //   path: 'reports',
  //   canActivate: [NgxPermissionsGuard],
  //   loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
  // },
  // {
  //   path: 'report',
  //   canActivate: [NgxPermissionsGuard],
  //   data: {
  //     permissions: {
  //       only: 'Line Management',
  //       redirectTo: unauthorized,
  //     }
  //   },
  //   component: ReportComponent
  // },
  {
    path: 'no-privilage',
    component: UnauthorizedComponent
  },
  {
    path: '',
    redirectTo: 'process-charts',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
